<!-- 老人活动记录表 -->
<template>
    <div style="background:#F4F4F4">
        <el-row>
            <!-- <el-col :span="12" :offset="10">
                <h2 class="title">日常活动记录表</h2>
            </el-col> -->
            <el-col class="queryform">
                <el-form :inline="true" :model="queryform" class="demo-form-inline toolbar" style="color:#111111"
                    @submit.native.prevent>
                    <el-form-item label="老人姓名">
                        <el-input v-model="queryform.oldName" placeholder="请输入老人姓名" clearable
                            @keyup.enter.native.prevent="getOldFeeList"></el-input>
                    </el-form-item>
                    <el-form-item label="日期">
                        <el-date-picker v-model="queryform.dayStr" type="date" style="width: 240px"
                            value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
                    </el-form-item>
                    <el-form-item style="margin-left:20px">
                        <el-button type="primary" style="font-size:13px" icon="el-icon-search" size="small" plain
                            @click="queryActivity">查询</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
            <el-col>
                <el-table :data="tableData" :header-cell-style="{
                    'text-align': 'center',
                    'font-weight': '600',
                    color: '#2d2d2d',
                    'background-color': '#d4f5fa',
                }" :cell-style="cellStyle" :row-style="tableRowStyle" style="width: 100%">
                    <el-table-column prop="oldName" label="姓名" align="center"></el-table-column>
                    <el-table-column prop="oldIdCard" width="160px" :show-overflow-tooltip="true" label="身份证号"
                        align="center"></el-table-column>
                    <el-table-column prop="oneActivity" :label="columList[0]" align="center"></el-table-column>
                    <el-table-column prop="twoActivity" :label="columList[1]" align="center"></el-table-column>
                    <el-table-column prop="threeActivity" :label="columList[2]" align="center"></el-table-column>
                    <el-table-column prop="fourActivity" :label="columList[3]" align="center"></el-table-column>
                    <el-table-column prop="fiveActivity" :label="columList[4]" align="center"></el-table-column>
                    <el-table-column prop="sixActivity" :label="columList[5]" align="center"></el-table-column>
                    <el-table-column prop="sevenActivity" :label="columList[6]" align="center"></el-table-column>

                    <el-table-column label="操作" min-width="60px" align="center">
                        <template slot-scope="scope">
                            <el-button type="warning" size="mini" @click="showOldInfo(scope.row)">明细</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination style="color:#fff;text-align: center;margin-top:15px" background
                    layout="total, prev, pager, next" :total="total" @current-change="changePage"></el-pagination>
            </el-col>

            <!-- 活动log记录 -->
            <el-dialog title="设备日志" width="70%" :visible.sync="logListVisible" :close-on-click-modal="false">
                <el-table :data="logList" style="width: 100%" :row-style="tableRowStyle"
                    :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :header-cell-style="tableHeaderColor">
                    <el-table-column prop="deviceNo" label="设备编号">
                    </el-table-column>
                    <el-table-column prop="type" label="日志类型">
                        <template slot-scope="scope">
                            <span v-if="scope.row.type == 0">上下线</span>
                            <span v-else-if="scope.row.type == 1">事件</span>
                            <span v-else-if="scope.row.type == 2">报警</span>
                            <span v-else>通话</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="info" label="消息">
                    </el-table-column>
                    <el-table-column prop="remark" label="备注">
                    </el-table-column>
                    <el-table-column prop="createdTime" label="时间" width="180">
                    </el-table-column>
                </el-table>
                <el-pagination background @current-change="logListPageChange" :current-page="logListCurrentPage"
                    layout="total, prev, pager, next" :total="logListTotal" align="center" class="fenye"></el-pagination>
                <div slot="footer" class="dialog-footer" align="center">
                    <el-button @click.native="logListVisible = false">关 闭</el-button>
                </div>
            </el-dialog>

        </el-row>
    </div>
</template>
<script>
export default {
    name: "oldActivity",
    data() {
        return {
            tableData: [
            ],
            columList: [],
            total: 0,
            pageNum: 1,
            pageSize: 10,
            yearMonthStr: "",
            queryform: {
                dayStr: "",
            },
            currentOldIdCard: "",
            logListVisible: false,
            logList: [],
            logListCurrentPage: 1,
            logListTotal: 0,
            quertForm: {},
        };
    },
    methods: {
        changePage(val) {
            this.pageNum = val;
            this.getOldActivityList();
        },
        showOldInfo(row) {
            this.currentOldIdCard = row.oldIdCard;
            this.logListCurrentPage = 1;
            this.getLogList();
            this.logListVisible = true;
        },
        getLogList() {
            let params = {
                pageNum: this.logListCurrentPage,
                pageSize: 10,
                oldIdCard: this.currentOldIdCard
            };
            this.$postJson("dmc/log/queryOldLogList", params).then(res => {
                this.logList = res.result.list;
                this.logListTotal = res.result.total * 1;
            })
        },
        logListPageChange(val) {
            this.logListCurrentPage = val;
            this.getLogList();
        },
        cellStyle({ row, column, rowIndex, columnIndex }) {
            if (row.oneActivity === '无活动' && columnIndex == 2) {
                return 'text-align:center;font-size:15px;color: red;';
            } else if (row.twoActivity === '无活动' && columnIndex == 3) {
                return 'text-align:center;font-size:15px;color: red;';
            } else if (row.threeActivity === '无活动' && columnIndex == 4) {
                return 'text-align:center;font-size:15px;color: red;';
            } else if (row.fourActivity === '无活动' && columnIndex == 5) {
                return 'text-align:center;font-size:15px;color: red;';
            } else if (row.fiveActivity === '无活动' && columnIndex == 6) {
                return 'text-align:center;font-size:15px;color: red;';
            } else if (row.sixActivity === '无活动' && columnIndex == 7) {
                return 'text-align:center;font-size:15px;color: red;';
            } else if (row.sevenActivity === '无活动' && columnIndex == 8) {
                return 'text-align:center;font-size:15px;color: red;';
            } else {
                return 'text-align:center;font-size:13px;'
            }
        },

        // 修改table header的背景色
        tableHeaderColor({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
            }
        },
        //修改table tr行的背景色
        tableRowStyle({ row, rowIndex }) {
            if (rowIndex % 2 == 0) {
                return "background-color: #ffffff";
            } else {
                return "background-color: #e4f5f8";
            }
        },
        //表格颜色
        rowStyle(row) {
            if (row.rowIndex % 2 == 0) {
                return { background: "#086abb", color: "#fff" };
            } else {
                return { background: "#3c8dd4", color: "#fff" };
            }
        },
        getOldActivityList() {
            let param = {
                oldName: this.queryform.oldName,
                dayStr: this.queryform.dayStr,
                pageNum: this.pageNum,
                pageSize: this.pageSize,
            };
            this.yearMonthStr = this.queryform.dayStr;
            this.$postJson("dmc/oldmanDevices/getWeekActivity", param).then((res) => {
                this.total = Number(res.result[0].pageInfo.total); //页码total
                this.convertData(res.result)
            });
        },
        convertData(dataList) {
            let oldDayActivity = [];
            let columList = [];
            if (dataList != null && dataList.length == 7) {
                for (let i = 0; i < dataList.length; i++) {
                    columList.push(dataList[i].dayStr)
                }
                for (let i = 0; i < dataList[0].pageInfo.list.length; i++) {
                    let item = {
                        oldName: dataList[0].pageInfo.list[i].oldmanName,
                        oldIdCard: dataList[0].pageInfo.list[i].oldIdCard,
                        oneActivity: dataList[0].pageInfo.list[i].info || '无活动',
                        twoActivity: dataList[1].pageInfo.list[i].info || '无活动',
                        threeActivity: dataList[2].pageInfo.list[i].info || '无活动',
                        fourActivity: dataList[3].pageInfo.list[i].info || '无活动',
                        fiveActivity: dataList[4].pageInfo.list[i].info || '无活动',
                        sixActivity: dataList[5].pageInfo.list[i].info || '无活动',
                        sevenActivity: dataList[6].pageInfo.list[i].info || '无活动',
                    }
                    oldDayActivity.push(item);
                }
            }
            console.log(columList);
            console.log(oldDayActivity);
            this.tableData = oldDayActivity; //列表数据
            this.columList = columList;
        },
        getNowFormatDate() {
            var date = new Date();
            var seperator1 = "-";
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            var day = date.getDate();
            if (day >= 1 && day <= 9) {
                day = "0" + day;
            }
            var currentdate = year + seperator1 + month + seperator1 + day;
            return currentdate;
        },
        queryActivity() {
            this.getOldActivityList();
        }
    },
    mounted() {
        this.queryform.dayStr = this.getNowFormatDate();
        this.getOldActivityList();
    }
};
</script>
<style scoped>
.title {
    font-size: 32px;
    margin-top: 6px;
}

.table {
    width: 100%;
    margin-top: 20px;
    border-color: #7EC0EE;
    border: 1px solid #76B8D3;
}
</style>
